import MarketplaceBanner from './MarketplaceBanner'

export default MarketplaceBanner
